<template>
  <div class="container">
    <div class="columns is-centered">
      <div class="column is-12 help-info">
        <h2>{{ $ml.get('help_text_1') }}</h2>
        <div class="article">
          <b>{{ $ml.get('help_text_2') }}</b> {{ $ml.get('help_text_3') }} <br>{{ $ml.get('help_text_4') }} <br>{{ $ml.get('help_text_5') }}
        </div>
        <h2>{{ $ml.get('help_text_6') }}</h2>
        <div class="article">
          <ul>
            <li>
              {{ $ml.get('help_text_7') }}
            </li>
            <li>
              {{ $ml.get('help_text_8') }}
              <b-icon size="is-small" icon="wallet"/>
              {{ $ml.get('help_text_9') }}
            </li>
            <li>
              {{ $ml.get('help_text_10') }}
            </li>
            <li>
              {{ $ml.get('help_text_11') }}
            </li>
            <li>
              {{ $ml.get('help_text_12') }} <b-icon icon="play" size="is-small"></b-icon>{{ $ml.get('help_text_13') }}
            </li>
            <li>
              {{ $ml.get('help_text_14') }}
            </li>
            <li>
              {{ $ml.get('help_text_15') }}:
            </li>
          </ul>
        </div>
        <h2>{{ $ml.get('help_text_16') }}</h2>
        <div class="article">
          <ul>
            <li>
              {{ $ml.get('help_text_17') }}
            </li>
            <li>
              {{ $ml.get('help_text_18') }}
            </li>
            <li>
              {{ $ml.get('help_text_19') }}
            </li>
            <li>
              {{ $ml.get('help_text_20') }}
            </li>
            <li>
              {{ $ml.get('help_text_21') }}
            </li>
          </ul>
        </div>
        <h2>{{ $ml.get('help_text_22') }}</h2>
        <div class="article">
          <ul>
            <li>
              {{ $ml.get('help_text_23') }}<br>
              <a href="https://www.vdsina.com/?partner=jeud2m1x5t" target="_blank">vdsina</a><br>
              <a href="https://macloud.ru/?partner=uxg6l4j1uv" target="_blank">macloud</a><br>
              <a href="https://aeza.net/?ref=455769" target="_blank">aeza</a>
            </li>
            <li>
              {{ $ml.get('help_text_27') }}
            </li>
            <li>
              {{ $ml.get('help_text_28') }}<br>
              <a href="https://proxyline.net?ref=36306" target="_blank">{{ $ml.get('help_text_29') }}</a><br>
              <a href="https://proxys.io/?refid=2441" target="_blank">{{ $ml.get('help_text_30') }}</a><br>
              <a href="https://proxy-sale.com/?partner_link=f4oPSMd4mV" target="_blank">{{ $ml.get('help_text_31') }}</a>
            </li>
            <li>
              {{ $ml.get('help_text_32') }}<br>
              <a href="https://go.gologin.com/betexy-IDNBDGA" target="_blank">{{ $ml.get('help_text_33') }}</a><br>
              <a href="https://browser.vision/r/5eb532b6-007f-4a33-b99c-f19d885896ef" target="_blank">{{ $ml.get('help_text_34') }}</a><br>
              <a href="https://share.adspower.net/betexy" target="_blank">{{ $ml.get('help_text_35') }}</a>
            </li>
          </ul>
        </div>
        <h2 id="contacts">{{ $ml.get('help_text_36') }}</h2>
        <div class="article">
          {{ $ml.get('help_text_37') }} <a target="_blank" :href="$ml.get('help_text_39')">{{ $ml.get('help_text_38') }}</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Help",
  computed: {
    manualLink() {
      return this.$ml.get('help_text_39');
    },
  },
  metaInfo() {
    return {
      title: this.$ml.get('titles_pages_help'),
    }
  }
}
</script>

<style scoped>

</style>
